module.exports = {
  footerText: 'Copyright Wieldy © 2019',
}
